import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { seasons } from '../../data/site';
export function SeasonsSection() {
  const [activeId, setActiveId] = useState(seasons[0].id);
  const reduce = useReducedMotion();
  const active = seasons.find(s => s.id === activeId) ?? seasons[0];
  const onKeyDown = (e: React.KeyboardEvent, index: number) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    const next = (index + (e.key === 'ArrowRight' ? 1 : -1) + seasons.length) % seasons.length;
    setActiveId(seasons[next].id);
    document.getElementById(`season-tab-${seasons[next].id}`)?.focus();
  };
  return <section aria-labelledby="seasons-title" className="bg-cream-dark" data-id="element-185" data-mp="20s8cjnkk61k2">
      <div className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28" data-id="element-186" data-mp="377j0tni3p2zi">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-187" data-mp="379dceb7hfiqx">
          <div data-id="element-188" data-mp="3c4j09fkg37hn">
            <h2 id="seasons-title" className="font-serif text-4xl font-medium leading-tight text-forest md:text-5xl" data-id="element-189" data-mp="3c86t0ci2fpvb">
              Le jardin au fil des saisons
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink-muted" data-id="element-190" data-mp="1yy0oiar65dsj">
              Chaque travail a son moment. Voici ce que je fais dans votre jardin, saison après saison.
            </p>
          </div>

          <div role="tablist" aria-label="Saisons" className="flex flex-wrap gap-2" data-id="element-191" data-mp="1pyvrj8v99sih">
            {seasons.map((season, index) => {
            const selected = season.id === activeId;
            return <button key={season.id} id={`season-tab-${season.id}`} role="tab" type="button" aria-selected={selected} aria-controls="season-panel" tabIndex={selected ? 0 : -1} onClick={() => setActiveId(season.id)} onKeyDown={e => onKeyDown(e, index)} className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-medium transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-forest ${selected ? 'bg-forest text-cream' : 'bg-cream text-ink hover:bg-white'}`} data-id="element-192" data-mp="1b7mysqw23r14" data-mpi={index}>
                  {season.name}
                </button>;
          })}
          </div>
        </div>

        <div id="season-panel" role="tabpanel" aria-labelledby={`season-tab-${active.id}`} className="mt-12 rounded-xl bg-cream p-8 md:p-12" data-id="element-193" data-mp="16b9bszzk0vd8">
          <AnimatePresence mode="wait" initial={false} data-id="element-194" data-mp="wkesa3dp09vh">
            <motion.div key={active.id} initial={reduce ? false : {
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={reduce ? undefined : {
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 md:grid-cols-12" data-id="element-195" data-mp="11jraubxj6us9">
              <div className="md:col-span-5" data-id="element-196" data-mp="3eowbcskjr437">
                <p className="text-sm font-medium text-clay" data-id="element-197" data-mp="39s60cjnlmyon">{active.months}</p>
                <h3 className="mt-2 font-serif text-4xl text-forest" data-id="element-198" data-mp="3ogk8na3sbfcl">{active.name}</h3>
                <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-199" data-mp="3oid74248ut9i">{active.intro}</p>
              </div>
              <ul className="divide-y divide-line md:col-span-7" data-id="element-200" data-mp="2vrv3mzzlypvk">
                {active.tasks.map(task => <li key={task} className="flex items-baseline gap-4 py-4 first:pt-0 last:pb-0" data-id="element-201" data-mp="2qtbih1su9i49">
                    <span className="h-1.5 w-1.5 shrink-0 translate-y-[-2px] rounded-full bg-moss" aria-hidden="true" data-id="element-202" data-mp="34t2tqurz0kek" />
                    <span className="text-lg text-ink" data-id="element-203" data-mp="30pwn3m0y4r7k">{task}</span>
                  </li>)}
              </ul>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}